"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("html", [_c("head"), _c("body", [_c("h1", [_vm._v("FormulaEditor 公式编辑组件")]), _c("p", [_vm._v("用于编辑计算公式，支持普通的数字运算、从科目库添加科目、选择已有公式科目。")]), _c("p", [_vm._v("目前使用到的应用场景包括：租户后台的公共报表、业绩解码项目的智能报表、智能看板等模块中的计算公式编辑。")]), _c("h2", [_vm._v("代码演示")]), _c("pre", {
    pre: true
  }, [_c("code", {
    pre: true,
    attrs: {
      "v-pre": "",
      class: "language-js"
    }
  }, [_vm._v("<template>\n  "), _c("span", {
    pre: true,
    attrs: {
      class: "language-xml"
    }
  }, [_c("span", {
    pre: true,
    attrs: {
      class: "hljs-tag"
    }
  }, [_vm._v("<"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-name"
    }
  }, [_vm._v("FormulaEditor")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("ref")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"formulaEditor"')]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v(":params")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"params"')]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v(":record")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"form"')]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v(":showSelectFormulaEntry")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"true"')]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("@change")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"onChange"')]), _vm._v(">")]), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-tag"
    }
  }, [_vm._v("</"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-name"
    }
  }, [_vm._v("FormulaEditor")]), _vm._v(">")])]), _vm._v("\n</template>\n\n"), _c("span", {
    pre: true,
    attrs: {
      class: "language-xml"
    }
  }, [_c("span", {
    pre: true,
    attrs: {
      class: "hljs-tag"
    }
  }, [_vm._v("<"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-name"
    }
  }, [_vm._v("script")]), _vm._v(">")]), _c("span", {
    pre: true,
    attrs: {
      class: "language-javascript"
    }
  }, [_vm._v("\n"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("import")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title class_"
    }
  }, [_vm._v("FormulaEditor")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("from")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v("'@ys/micro-components/FormulaEditor'")]), _vm._v("\n\n"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("components")]), _vm._v(": {\n    "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title class_"
    }
  }, [_vm._v("FormulaEditor")]), _vm._v("\n  },\n  "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title function_"
    }
  }, [_vm._v("data")]), _vm._v("("), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-params"
    }
  }), _vm._v(") {\n   "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n     "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("form")]), _vm._v(": {\n      "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("formulaCode")]), _vm._v(": "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-literal"
    }
  }, [_vm._v("undefined")]), _vm._v(", "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-comment"
    }
  }, [_vm._v("// 自定义公式编码")]), _vm._v("\n      "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("formulaName")]), _vm._v(": "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-literal"
    }
  }, [_vm._v("undefined")]), _vm._v(", "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-comment"
    }
  }, [_vm._v("// 自定义公式名称")]), _vm._v("\n      "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("formulaRules")]), _vm._v(": [] "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-comment"
    }
  }, [_vm._v("// 公式规则数组-非接口参数")]), _vm._v("\n     }\n   }\n  },\n  "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("method")]), _vm._v(": {\n    "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title function_"
    }
  }, [_vm._v("onChange")]), _vm._v("("), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-params"
    }
  }, [_vm._v("res")]), _vm._v("){\n      "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-variable language_"
    }
  }, [_vm._v("this")]), _vm._v("."), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-property"
    }
  }, [_vm._v("form")]), _vm._v(" = "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title class_"
    }
  }, [_vm._v("Object")]), _vm._v("."), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title function_"
    }
  }, [_vm._v("assign")]), _vm._v("("), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-variable language_"
    }
  }, [_vm._v("this")]), _vm._v("."), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-property"
    }
  }, [_vm._v("form")]), _vm._v(", res)\n    }\n  }\n}\n")]), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-tag"
    }
  }, [_vm._v("</"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-name"
    }
  }, [_vm._v("script")]), _vm._v(">")])]), _vm._v("\n")])]), _c("p", [_vm._v("组件效果： "), _c("img", {
    attrs: {
      src: "1.png",
      alt: "组件效果"
    }
  })]), _c("h2", [_vm._v("API")]), _c("table", [_c("thead", [_c("tr", [_c("th", [_vm._v("参数")]), _c("th", [_vm._v("说明")]), _c("th", [_vm._v("类型")]), _c("th", [_vm._v("默认值")]), _c("th", [_vm._v("版本")])])]), _c("tbody", [_c("tr", [_c("td", [_vm._v("record")]), _c("td", [_vm._v("当前正在编辑的记录，格式如："), _c("code", {
    pre: true
  }, [_vm._v("{id,name,statType,type,formulaRules:[{key:'item',value:'#{9206911201001}',label:'#{京挑客}'}],formulaName:'#{京挑客}',formulaCode:'#{9206911201001}'}")]), _vm._v("，其中"), _c("code", {
    pre: true
  }, [_vm._v("formulaRules")]), _vm._v("为必须字段")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Object")])]), _c("td"), _c("td")]), _c("tr", [_c("td", [_vm._v("dataSource")]), _c("td", [_vm._v("当前正在编辑的模板数据源，格式：[record]")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Array")])]), _c("td"), _c("td")]), _c("tr", [_c("td", [_vm._v("showSelectFormulaEntry")]), _c("td", [_vm._v("是否显示“选择已有公式科目”入口，如果值为"), _c("code", {
    pre: true
  }, [_vm._v("true")]), _vm._v("时，则从"), _c("code", {
    pre: true
  }, [_vm._v("dataSource")]), _vm._v("中获取"), _c("code", {
    pre: true
  }, [_vm._v("statType")]), _vm._v("或"), _c("code", {
    pre: true
  }, [_vm._v("type")]), _vm._v("为"), _c("code", {
    pre: true
  }, [_vm._v("formula")]), _vm._v("的数据作为公式")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Boolean")])]), _c("td", [_vm._v("false")]), _c("td")]), _c("tr", [_c("td", [_vm._v("params")]), _c("td", [_vm._v("获取科目列表的接口参数 "), _c("code", {
    pre: true
  }, [_vm._v("{isDefault: 费用项是否默认，1-是，0-否, type: 类型，Default：普通，CustomFormula：自定义公式, Stat：统计科目, dimension: 统计维度，Shop：店铺，Anchor：主播，Sku：单品}")])]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Object")])]), _c("td", [_vm._v("{}")]), _c("td")]), _c("tr", [_c("td", [_vm._v("method")]), _c("td", [_vm._v("获取科目列表的请求方法")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Function或String")])]), _c("td", [_vm._v("/v1/cost/class/item")]), _c("td")]), _c("tr", [_c("td", [_vm._v("extra")]), _c("td", [_vm._v("组件布局最下方的插槽位置，用于添加额外的描述信息等")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Slot")])]), _c("td"), _c("td")])])]), _c("h2", [_vm._v("事件")]), _c("table", [_c("thead", [_c("tr", [_c("th", [_vm._v("事件名称")]), _c("th", [_vm._v("说明")]), _c("th", [_vm._v("回调参数")]), _c("th", [_vm._v("版本")])])]), _c("tbody", [_c("tr", [_c("td", [_vm._v("change")]), _c("td", [_vm._v("公式内容"), _c("code", {
    pre: true
  }, [_vm._v("formulaRules")]), _vm._v("有变化时的回调")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("({ formulaRules, formulaName, formulaCode }) => void")])]), _c("td", [_vm._v("-")])])])]), _c("h2", [_vm._v("方法")]), _c("table", [_c("thead", [_c("tr", [_c("th", [_vm._v("名称")]), _c("th", [_vm._v("描述")])])]), _c("tbody", [_c("tr", [_c("td", [_vm._v("clear()")]), _c("td", [_vm._v("清空公式内容"), _c("code", {
    pre: true
  }, [_vm._v("formulaRules")]), _vm._v("，同时触发"), _c("code", {
    pre: true
  }, [_vm._v("change")]), _vm._v("事件")])])])])])])]);
}];
render._withStripped = true;